import oem from '../assets/image/about/heading.webp';
import {useTranslation} from "react-i18next";
import {NewlineText} from "./common/NewlineText";

function AboutOemSection() {
    const {t} = useTranslation();
    return (
        <div className="relative">
            <img src={oem} alt="About Oem" className="object-cover h-[calc(75vh)] max-md:h-96 w-full" />
            <div className="absolute inset-0 p-24 max-md:p-12 flex-col max-md:w-2/3 max-w-screen-sm text-left">
                <h2 data-aos="fade-up" className="text-primary text-3xl max-md:text-xl font-bold">
                    {t('about_oem_title')}
                </h2>
                <h4 data-aos="fade-in" data-aos-duration="2000"
                    className="mt-4 text-xl max-md:text-sm font-bold">
                    <NewlineText text={t('about_oem_subtitle')}/>
                </h4>
            </div>
        </div>
    );
}

export default AboutOemSection;
